import { render } from "./NotFound.vue?vue&type=template&id=0b881771"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=0b881771&lang=scss"
script.render = render

export default script